import * as customTypes from './custom-types/api';
import * as preview from './preview/api';
import * as slices from './slices/api';

export const prismic = {
  preview,
  customTypes,
  slices,
};
